import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { postAuthProfile } from 'services/auth'

export default function useSetAuthProfile(
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>
) {
    const navigate = useNavigate()
    const { mutate } = useMutation({
        mutationFn: (payload: IAuthprofilePayload) => {
            return postAuthProfile(payload)
        },
        onSuccess: (_, variables) => {
            setShowModal(false)
            navigate('/funds')
        },
        onError: () => {
            toast.error('خطایی رخ داده')
        },
    })

    return { mutate }
}
